import { render, staticRenderFns } from "./addUserModal.vue?vue&type=template&id=bd318d84&scoped=true&"
import script from "./addUserModal.vue?vue&type=script&lang=js&"
export * from "./addUserModal.vue?vue&type=script&lang=js&"
import style0 from "./addUserModal.vue?vue&type=style&index=0&id=bd318d84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd318d84",
  null
  
)

export default component.exports